<template>
  <div class="table-responsive-sm">
    <table class="table b-table table-striped">
      <tbody class="">
      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
        <td width="150" style="background-color:#f1f1f1; font-weight:bold">
          <label class="col-form-label">주메뉴 대분류 *</label>
        </td>
        <td class="">
          <b-form-select id=""
                  name=""
                  style="width:50%; padding:15px 10px"
                  v-model="selectedMainMenuCode"
                  :plain="true"
                  @change="getMainMenuList()"
                  refs="mainSelect"
          >
            <option value="null">메뉴를 선택해 주세요</option>
            <option :value="cItems.item_code"
                    v-for="(cItems, idx) in mainMenu">{{cItems.item_name}}
            </option>
          </b-form-select>
        </td>
        <td width="150" style="background-color:#f1f1f1; font-weight:bold">
          <label class="col-form-label">주메뉴 소분류 *</label>
        </td>
        <td class="">
          <b-form-select id=""
                         name=""
                         style="width:50%; padding:15px 10px"
                         :plain="true"
                         v-model="selectedMainSubMenuCode"
                         @change="selectSubMenuCode('main')"
          >
            <option value="null">메뉴를 선택해 주세요</option>-->
            <option :value="cItems.item_code"
                    v-for="(cItems, idx) in subMenu">{{cItems.item_name}}</option>
          </b-form-select>
        </td>
      </tr>
      <!--  부메뉴    -->
      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
        <td width="150" style="background-color:#f1f1f1">
          <label class="col-form-label">부메뉴 대분류</label>
        </td>
        <td class="">
          <b-form-select id="minorMenuCode"
                         v-model="selectedMinorCode"
                         :plain="true"
                         style="width:50%; padding:15px 10px"
                         @change="getMinorMenuList()"
          >
            <option value="null">메뉴를 선택해 주세요</option>
            <option :value="cItems.item_code"
                    v-for="(cItems, idx) in minorMenu">{{cItems.item_name}}
            </option>
          </b-form-select>

        </td>
        <td width="150" style="background-color:#f1f1f1">
          <label class="col-form-label">부메뉴 소분류</label>
        </td>
        <td class="">
          <b-form-select
            id="minorSubMenuCode"
            v-model="selectedMinorSubCode"
            :plain="true"
            style="width:50%; padding:15px 10px"
            @change="selectSubMenuCode('minor')"
          >
            <option :value="cItems.item_code"
                    v-for="(cItems, idx) in minorSubMenu">{{cItems.item_name}}
            </option>
          </b-form-select>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

  import { codeAPI } from '../../../common/code.js';

    export default {
        name: "ReportMenuComponent",
        props: ['reportmenu'],
        data() {
          return {
            selectedMainMenuCode : null,
            selectedMainSubMenuCode : '',
            selectedMinorCode : null,
            selectedMinorSubCode : '',
            mainMenu : [],
            subMenu : [],
            minorMenu : [],
            minorSubMenu : [],
            allMenuCode : []
          }
        },
      computed: {
     },
      created() {
        codeAPI.selectItemCodeList(this,"RPT_TYPE",2,"mainMenu");
        codeAPI.selectItemCodeList(this,"RPT_TYPE",2,"minorMenu");
      },
      mounted() {
          if(this.reportmenu.dr_type_code){
            //주
            this.selectedMainMenuCode = this.reportmenu.dr_type_code
            this.getMainMenuList()
            this.selectedMainSubMenuCode = this.reportmenu.type_code
          }

          if(this.reportmenu.sub_main_type_code){
            //부
            this.selectedMinorCode = this.reportmenu.sub_main_type_code
            this.getMinorMenuList()
            console.log(this.reportmenu.sub_type_code)
            this.selectedMinorSubCode = this.reportmenu.sub_type_code
          }
      },
      methods: {
        selectSubMenuCode(subMenuType){
          if('main' === subMenuType){
            this.$emit("setMenuCode", subMenuType, this.selectedMainSubMenuCode)
          }else {
            this.$emit("setMenuCode", subMenuType, this.selectedMinorSubCode)
          }
        },
        getMainMenuList(menuType){
          codeAPI.selectItemCodeList(this,this.selectedMainMenuCode,3,"subMenu");

        },
        getMinorMenuList(menuType){
          codeAPI.selectItemCodeList(this,this.selectedMinorCode,3,"minorSubMenu");
        }

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/contents/component/ReportMenuComponent.vue